if (typeof ImageRotator === 'undefined') {
    /*
    * Image rotation helper stuff.
    * http://kenwheeler.github.io/slick/
    */
    var ImageRotator = (function ($) {

        function ready() {
            // Get fancybox ready.
            if (typeof $.fn.fancybox === 'function') {
                $('a[rel^=image-gallery]').fancybox();
            }

            var settings = {
                desktop: {
                    slidesToShow: 3,
                    //slideToScroll: 1,
                    centerMode: false,
                    speed: 1000,
                    infinite: false,
                    variableWidth: true,
                    easing: 'easeOutQuart',
                    useCSS: false,
                    waitForAnimate: false,
                    //$easeOutQuart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);
                    //cssEase: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
                    prevArrow: '<span class="prev icon-chevron-left-circle"></span>',
                    nextArrow: '<span class="next icon-chevron-right-circle"></span>',
                    dots: false,
                    focusOnSelect: true,
                    accessibility: true
                },
                videoDesktop: {
                    //slidesToShow: 3,
                    //slideToScroll: 1,
                    centerMode: false,
                    speed: 1000,
                    infinite: false,
                    variableWidth: true,
                    easing: 'easeOutQuart',
                    useCSS: false,
                    waitForAnimate: false,
                    //$easeOutQuart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);
                    //cssEase: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
                    prevArrow: '<span class="prev icon-chevron-left-circle"></span>',
                    nextArrow: '<span class="next icon-chevron-right-circle"></span>',
                    dots: false,
                    focusOnSelect: true,
                    accessibility: true
                },
                mobile: {
                    slidesToShow: 1,
                    slideToScroll: 1,
                    centerMode: false,
                    speed: 1000,
                    infinite: false,
                    //variableWidth: true,
                    easing: 'easeOutQuart',
                    useCSS: false,
                    waitForAnimate: false,
                    //$easeOutQuart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);
                    //cssEase: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
                    prevArrow: '<span class="prev icon-chevron-left-circle"></span>',
                    nextArrow: '<span class="next icon-chevron-right-circle"></span>',
                    dots: false,
                    focusOnSelect: true,
                    accessibility: true
                },
                videoMobile: {
                    slidesToShow: 3,
                    slideToScroll: 1,
                    centerMode: false,
                    speed: 1000,
                    infinite: false,
                    //variableWidth: true,
                    easing: 'easeOutQuart',
                    useCSS: true,
                    waitForAnimate: false,
                    //$easeOutQuart:    cubic-bezier(0.165,  0.840, 0.440, 1.000);
                    //cssEase: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
                    prevArrow: '<span class="prev icon-chevron-left-circle"></span>',
                    nextArrow: '<span class="next icon-chevron-right-circle"></span>',
                    dots: false,
                    focusOnSelect: true,
                    accessibility: true,
                    responsive: [
                        {
                            breakpoint: 740,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 430,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]

                }
            };

            if (typeof $.fn.slick === 'function') {
                // Initialize Slick slider.
                var rotator = $(".rotator");
                rotator.on('init', window.SlickSettings.slickInit);
                rotator.on("afterInit", window.SlickSettings.slickAfterInit);
                rotator.slick(BreakpointController.isMobile() ? settings.mobile : settings.desktop);

              


                var rotator1 = $(".rotatorVideo");
                rotator1.on('init', window.SlickSettings.slickInit);
                rotator1.on("afterInit", window.SlickSettings.slickAfterInit);
                rotator1.slick(BreakpointController.isMobile() ? settings.videoMobile : settings.videoDesktop);

            }
        }

        $(ready);

        return {
            ready: ready
        };

    })(jQuery);
}

if (typeof ImageCarousel === 'undefined') {
    /*
    * Logic for image carousel control.
    */
    ImageCarousel = (function ($) {

        var carouselHeight, carouselBlock, imgDataItems;

        function setHeightOnContainers() {
            carouselBlock.css("height", carouselHeight + "px");
            carouselBlock.children().first().css("height", carouselHeight + "px");
            imgDataItems.each(function () {
                $(this).children().first().css("height", carouselHeight + "px");
            });
        }

        function ready() {
            carouselBlock = $("#carouselBlock");
            imgDataItems = $(".imgData .imgDataItem");
            carouselHeight = window.CarouselHeight;

            //if (carouselHeight) {
            //    setHeightOnContainers();
            //}

            $("a[rel^=image-carousel]")
                .on('click',
                function (e) {
                    var link = $(this);
                    // Only prevent default action if this is not a modal trigger or video.
                    if (!link.is('.modal-trigger') && !link.is(".video")) {
                        e.preventDefault();
                    }

                    var position = link.index();
                    if (position != null) {
                        carouselBlock.stop(true, true)
                            .animate({
                                opacity: 0.0
                            },
                            250,
                            'easeOutQuart',
                            function () {
                                var item = imgDataItems.filter("#img-" + position);
                                carouselBlock.html(item.html());
                                carouselBlock.stop(true, true).animate({ opacity: 1.0 }, 250, 'easeOutQuart');
                            }
                            );
                    }

                });
        }

        $(ready);

    })(jQuery);
}